<template>
  <div class="home">
   <progressDialog v-bind:loadingContent="loadingContent" />
   <v-data-table
      v-if="!loadingContent"
      :headers="headers"
      :items="drives"
      sort-by="sort"
      class="elevation-1"
      :footer-props="{
        'items-per-page-options': [10, 50, 100]
      }"
      :items-per-page="50"
    >
      <template v-slot:top>
        <v-toolbar flat color="muted">
          <v-toolbar-title>Credenciais dos Drives</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-btn icon color="primary" v-on:click="newItem">
            <v-icon>mdi-plus</v-icon>
          </v-btn>

          <DialogItem ref="dialogItem"
            v-bind:open="openDialogItem"
            v-bind:editedItem="editedItem"
            v-bind:editing="editing"
            v-on:closeDialogItem="closeDialogItem"
            v-on:saveDialogItem="saveDialogItem" />

        </v-toolbar>
        <flash-message />
        <DeletionConfirmationModal :open="deleting" :item="deletedItem" @close="stopDeletingItem" @confirm="confirmItemDeletion"/>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          class="mr-2"
          @click="deleteItem(item)"
        >
          mdi-trash-can-outline
        </v-icon>
      </template>
      <template v-slot:item.active="{ item }">
        <onOffItem v-bind:value="item.active" />
      </template>
      <template v-slot:no-data>
        Não há drives cadastrados
      </template>
    </v-data-table>
    <v-snackbar
      top
      timeout="20000"
      multi-line
      v-model="snackbar"
    >
      {{ snackbartext }}
      <v-btn flat @click.native="snackbar = false">Fechar</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import onOffItem from '@/components/on-off-item/index.vue';
import progressDialog from '@/components/progress-dialog/progressDialog.vue';
import DeletionConfirmationModal from '@/components/deletion-confirmation-modal/index.vue';
import DialogItem from './DialogItem.vue';
import DrivesService from '../../service/DrivesService';

export default {
  name: 'Drives',
  components: {
    DialogItem,
    onOffItem,
    progressDialog,
    DeletionConfirmationModal,
  },

  data: () => ({
    snackbartext: '',
    snackbar: false,
    content: [],
    loadingContent: true,
    loadingError: false,
    headers: [
      { text: '', sortable: false, value: 'actions' },
      { text: 'Id', value: 'id' },
      { text: 'Tipo', value: 'type' },
      { text: 'Code', value: 'credentialCode' },
      { text: 'Nome', value: 'name' },
      { text: 'Descricao', value: 'description' },
      { text: 'Diretório', value: 'initDirectory' },
      { text: 'Share', value: 'share' },
      { text: 'Protocol', value: 'protocol' },
      { text: 'Account Name', value: 'accountName' },
      { text: 'Account Key', value: 'accountKey' },
      { text: 'Ativa', value: 'active' },
    ],
    drives: [],
    openDialogItem: false,
    editedItem: {},
    editing: false,
    deletedItem: {},
    deleting: false,
  }),

  created() {
    this.initialize();
  },

  methods: {
    hiddenLoading() {
      this.loadingContent = false;
    },
    showLoading() {
      this.loadingContent = true;
    },
    initialize() {
      DrivesService.findAll().then((response) => { this.drives = response.data; }).finally(() => this.hiddenLoading());
    },
    newItem() {
      this.editedItem = { active: true };
      this.openDialogItem = true;
      this.editing = false;
    },

    editItem(item) {
      this.editedItem = item;
      this.openDialogItem = true;
      this.editing = true;
    },

    deleteItem(item) {
      this.deletedItem = item;
      this.deleting = true;
    },
    stopDeletingItem() {
      this.deleting = false;
      this.deletedItem = {};
    },
    confirmItemDeletion(item) {
      this.deleting = false;
      this.showLoading();
      DrivesService.delete(item.id).then(() => {
        const deleteIndex = this.drives.findIndex((r) => r.id === item.id);
        this.drives.splice(deleteIndex, 1);
      }).catch(() => this.showMessageErro('Ocorreu um erro ao excluir o registro')).finally(() => this.hiddenLoading());
    },
    closeDialogItem() {
      this.openDialogItem = false;
      this.editedItem = {};
    },

    saveDialogItem(saved) {
      // this.showLoading();
      if (this.editing) {
        DrivesService.update(saved)
          .then((response) => {
            const editedIndex = this.drives.findIndex((r) => r.id === response.data.id);
            Object.assign(this.drives[editedIndex], response.data);
            this.openDialogItem = false;
            this.hiddenLoading();
          })
          .catch((error) => {
            this.hiddenLoading();
            this.snackbar = true;
            if (error && error.response && error.response.status !== 500) {
              this.snackbartext = `Ocorreu um erro ao inserir o registro: ${error.response.data} `;
            } else {
              this.snackbartext = 'Ocorreu um erro ao inserir o registro!';
            }
            this.editedItem = saved;
            this.openDialogItem = true;
          });
      } else {
        DrivesService.create(saved)
          .then((response) => {
            this.drives.push(response.data);
            this.openDialogItem = false;
            this.hiddenLoading();
          })
          .catch((error) => {
            this.hiddenLoading();
            this.snackbar = true;
            if (error && error.response && error.response.status !== 500) {
              this.snackbartext = `Ocorreu um erro ao inserir o registro: ${error.response.data} `;
            } else {
              this.snackbartext = 'Ocorreu um erro ao inserir o registro!';
            }
            this.editedItem = saved;
            this.openDialogItem = true;
          });
      }
    },
    showMessageErro(message) {
      this.flash(message, 'error', { timeout: 5000 });
      this.serviceErro = true;
    },
  },
};
</script>
<style scoped>
  .tdexpand {
    padding: 10px;
    box-shadow: none;
  }
</style>
